import React from 'react';
import useFieldHelper from '../fieldHelper';
import TextField from './TextField';
import { FieldProps } from '../types';

export interface EnumFieldProps extends FieldProps {
  options: Dictionary<string>;
}

const EnumField = ({ options, ...props }: EnumFieldProps) => {
  const { getValue, getLabel } = useFieldHelper(props);

  const displayValue = options[getValue()];

  return <TextField value={displayValue} label={getLabel()} />;
};

export default EnumField;
